import { Annotation, LessonContainer } from 'components';

export const props: GameLessonProps = {
    communityCardsSides: ['front', 'front', 'front'],
    communityCards: ['jc', '5h', 'kd'],
    hideCardButton: true,
    holeCards: ['ah', 'ac'],
    opponentsCards: [['kh', 'ks']],
    reset: true,
    round: 'opponents',
};

export default function Lesson_1_1() {
    return (
        <LessonContainer>
            <Annotation arrow="-50,-20,0,-1" index={1} left="calc(50% + 150px)" top={100} width={150} />
            <Annotation arrow="120,0,20" index={2} left="calc(50% - 350px)" top={120} width={150} />
            <Annotation arrow="110,50" flip index={3} left="calc(50% - 300px)" top={450} width={150} />
        </LessonContainer>
    );
}
